import UserViewsChart from './UserViewsChart'

export default UserViewsChart
